import React from "react";
import { Line } from "react-chartjs-2";

export default function VyvojGrafKarta({
  zostatky,
  data,
  chartOptions,
  chartRef,
}) {
  if (!zostatky?.length) return null;

  return (
    <div className="card-section card-section--chart">
      <h2>Vývoj zostatku hypotéky</h2>
      <div className="chart-wrap">
        <Line ref={chartRef} data={data} options={chartOptions} />
      </div>
    </div>
  );
}